import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getStateList = createAsyncThunk(
  "state/list",
  async ({ pageCount, limit, search }) => {
    const response = await Client(
      API_METHOD.GET,
      url.states +
        `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${
          !search ? "" : search
        }`
    );
    return response.data;
  }
);

export const addState = createAsyncThunk(
  "state/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.states, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editState = createAsyncThunk(
  "state/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.states + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getStateCount = async () =>{
  const response = await Client(API_METHOD.GET, url.states)
  return response.data?.data?.item?.total_count;
}

export const getState = createAsyncThunk("state/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.states + `/${id}`);
  return response.data;
});

